import { withPluginApi } from "discourse/lib/plugin-api";

export default {
  name: "register-category-type-callback",
  initialize(container) {
    withPluginApi((api) => {
      const upgradeService = container.lookup("service:upgrade");

      if (!api.registerOnBeforeCategoryTypesChange) {
        return;
      }

      api.registerOnBeforeCategoryTypesChange(({ nextTypes }) => {
        let needsUpgrade = false;

        nextTypes.forEach((type) => {
          if (needsUpgrade) {
            return false;
          }

          if (!type.available) {
            needsUpgrade = true;
            upgradeService.modalForPlan(
              type.required_tier,
              `/edit-category/add-type ${type.id} category`
            );
          }
        });

        return !needsUpgrade;
      });
    });
  },
};
